import { ContentState, EditorState } from "draft-js";
import styled from "styled-components";

export const Wrapper = styled.div`
  .header {
    border-bottom: 1px solid #eaeaea;
    padding: 24px;
    max-height: 72px;
    position: sticky;
    top: 0;
    background: #fff;
    z-index: 10;
  }

  .contentBody {
    overflow: hidden;
  }

  .postAreaContainer {
    display: flex;
    flex-direction: column;
    gap: 24px;
    background-color: #f8f8f8;
    flex: 1;
    height: calc(100vh - 72px);
    padding: 24px 24px 24px 84px;
  }

  .postArea {
    display: flex;
    padding: 24px 24px 0 24px;
    flex-direction: column;
    gap: 24px;
    border-radius: 8px;
    background: #fff;
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.05),
      0px 25px 35px 0px rgba(0, 0, 0, 0.03);
    max-height: 90%;
    overflow-y: auto;

    &.result {
      padding: 24px;
      max-height: 450px;
      padding-bottom: 0;
    }
  }

  .socialsList {
    display: flex;
    gap: 12px;

    .socialIconWrapper {
      display: flex;
      width: 40px;
      height: 40px;
      padding: 10px;
      justify-content: center;
      align-items: center;
      border-radius: 100px;
      border: solid #e2e2ea;
      background: #fafafa;
      cursor: pointer;
    }
  }

  .postBox {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex: 1 0 0;
    border-radius: 8px;
    border: solid #e2e2ea;
    background: #fff;
  }

  .uploadArea {
    display: flex;
    padding: 4px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
    flex: 1 0 0;
    align-self: stretch;
    border: 2px dashed #e2e2ea;
    border-radius: 8px;
    min-height: 250px;
    background: #f8f8f8;

    &:hover {
      border-color: #149dff;
      color: #149dff;
    }

    input {
      display: none;
    }
  }

  .textarea {
    padding: 12px;
    border: 1px solid #e2e2ea;
    border-radius: 8px;
    outline: none;
    resize: none;
    height: 200px;
    font-size: 14px;
    transition: border-color 0.2s;

    &::placeholder {
      color: #8e8e8e;
      font-size: 14px;
    }

    &:focus {
      border-color: #0095f6;
    }
  }

  .showMore {
    display: flex;
    padding: 4px 8px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 24px;
    border: 1px solid #149dff;
    background: #fff;
  }

  .footer {
    padding: 24px 0;
    position: sticky;
    bottom: 0;
    background: #fff;
  }

  .actionCenter {
    padding: 12px;
    display: flex;
    gap: 16px;
  }

  .imageContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 72px;
    width: 72px;
    border-radius: 8px;
    background-color: #f8f8f8;
    margin: 12px;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 8px;
    }
  }

  .imageContainerPreview {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 280px;
    width: 280px;
    border-radius: 8px;
    background-color: #f8f8f8;
    position: relative;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 8px;
    }

    .deleteIcon {
      position: absolute;
      bottom: 0;
      right: 0;
      background: #fff;
      border-radius: 50%;
      padding: 4px;
      cursor: pointer;
    }
  }

  .postIdeaCard {
    display: flex;
    padding: 6px 8px;
    justify-content: center;
    align-items: center;
    gap: 24px;
    border-radius: 8px;
    border: 1px solid #f2f3f7;
    background: var(--White, #fff);
    cursor: pointer;
  }

  .errorCard {
    display: flex;
    padding: 8px;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    border-radius: 8px;
    background: #ffebeb;
    font-size: 14px;
  }

  .generateMoreBtn {
    display: flex;
    width: 672px;
    padding: 20px 48px;
    justify-content: center;
    align-items: center;
    gap: 4px;
    border-radius: 8px;
    border: 1px dashed #e2e2ea;
    background: #fff;
    width: 100%;
    cursor: pointer;
  }

  @media (max-width: 768px) {
    .contentBody {
      flex-direction: column;
      gap: 24px;
    }

    .postAreaContainer {
      padding: 24px;
      width: 100%;
    }

    .resultBtn {
      span {
        display: none;
      }
    }
  }
`;

export const InputWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;

  .instagram-icon {
    position: absolute;
    left: 12px;
    color: #8e8e8e;
    pointer-events: none;
  }

  input {
    width: 100%;
    padding: 12px 12px 12px 40px;
    border: 1px solid #e2e2ea;
    border-radius: 8px;
    font-size: 14px;
    outline: none;
    transition: border-color 0.2s;

    &.noImage {
      padding-left: 12px;
    }

    &:focus {
      border-color: #0095f6;
    }

    &::placeholder {
      color: #8e8e8e;
      font-size: 14px;
    }
  }
`;

export const Divider = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 18px;
  position: relative;

  .text {
    position: relative;
    padding: 6px;
    background-color: var(--white);
    z-index: 1;
  }

  &::after {
    content: "";
    position: absolute;
    left: 0;
    width: 100%;
    height: 1px;
    background-color: var(--grey_10);
  }
`;

export const findHashtags = (contentBlock, callback, contentState) => {
  const text = contentBlock.getText();
  const regex = /#[\w]+/g;
  let match;
  while ((match = regex.exec(text)) !== null) {
    callback(match.index, match.index + match[0].length);
  }
};

export const findLinks = (contentBlock, callback, contentState) => {
  const text = contentBlock.getText();
  const regex = /(https?:\/\/\S+)/g;
  let match;
  while ((match = regex.exec(text)) !== null) {
    callback(match.index, match.index + match[0].length);
  }
};

export const findMentions = (contentBlock, callback, contentState) => {
  const text = contentBlock.getText();
  const regex = /@[\w]+/g;
  let match;
  while ((match = regex.exec(text)) !== null) {
    callback(match.index, match.index + match[0].length);
  }
};

export const HashtagSpan = (props) => (
  <span style={{ color: "#1DA1F2" }}>{props.children}</span>
);

export const LinkSpan = (props) => (
  <a href={props.children[0].props.text} style={{ color: "#1DA1F2" }}>
    {props.children}
  </a>
);

export const MentionSpan = (props) => (
  <span style={{ color: "#1DA1F2" }}>{props.children}</span>
);

export const typeCaption = (text, setEditorState, compositeDecorator) => {
  const words = text.split(" ");
  let index = 0;
  let currentCaption = "";

  const intervalId = setInterval(() => {
    const nextChunk = words.slice(index, index + 2).join(" ");
    currentCaption = currentCaption + (currentCaption ? " " : "") + nextChunk;

    // Create new EditorState with current text
    const newEditorState = EditorState.createWithContent(
      ContentState.createFromText(currentCaption),
      compositeDecorator
    );
    setEditorState(newEditorState);

    index += 2;
    if (index >= words.length) {
      clearInterval(intervalId);
    }
  }, 100);
};
